/**
 * Project Name: Brainsie eCommerce v4
 * Component: FAQ View Section (Dynamic)
 * Description: CMS wrapper for FaqView component with configurable settings
 * Author: Brainsie Team
 * Date Created: November 1, 2025
 */

import React from "react";
import { Box, Container } from "@mui/material";
import FaqView from "CommonComponents/Faqs/FaqView.jsx";

export default function FaqViewSection({
  section,
  darkMode,
  theme,
  headerRefresh,
  setHeaderRefresh,
}) {
  // Parse section settings with fallbacks
  const sectionSettings = section.Section_Settings
    ? JSON.parse(section.Section_Settings)
    : {};

  // console.log("❓ FAQ VIEW SECTION:", {
  //   sectionId: section.Section_Id,
  //   sectionCode: section.Section_Code,
  //   settings: sectionSettings,
  // });

  // Default settings with CMS overrides
  const settings = {
    // Layout settings
    paddingY: sectionSettings.paddingY || 6,
    paddingX: sectionSettings.paddingX || 0,
    maxWidth: sectionSettings.maxWidth || "lg",
    backgroundColor: sectionSettings.backgroundColor || "transparent",

    // Content settings - use section data headings
    showTitle: sectionSettings.showTitle !== false,
    customTitle: section.Section_Heading || sectionSettings.customTitle || "",
    customSubHeading:
      section.Section_Sub_Heading || sectionSettings.customSubHeading || "",
    customSubText:
      section.Section_Sub_Text || sectionSettings.customSubText || "",

    // FAQ specific settings
    showSearchFilter: sectionSettings.showSearchFilter !== false,
    showCategoryFilter: sectionSettings.showCategoryFilter !== false,
    expandFirstItem: sectionSettings.expandFirstItem !== false,
    maxItemsPerPage: sectionSettings.maxItemsPerPage || 10,

    // Custom styles
    customStyles: sectionSettings.customStyles || {},
  };

  return (
    <Box
      component="section"
      className="faq-view-section"
      sx={{
        py: settings.paddingY,
        px: settings.paddingX,
        backgroundColor: settings.backgroundColor,
        ...settings.customStyles,
      }}
    >
      <Container maxWidth={settings.maxWidth}>
        <FaqView
          sectionSettings={settings}
          darkMode={darkMode}
          theme={theme}
          headerRefresh={headerRefresh}
          setHeaderRefresh={setHeaderRefresh}
        />
      </Container>
    </Box>
  );
}
